import { Callout } from '@radix-ui/themes';
import { LogIn } from 'lucide-react';
import { useAuth } from './AuthProvider.tsx';
import './login.css';

export function LoginPage() {
  const { login, authError } = useAuth();
  const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  return (
    <div className="login-root">
      <div className="login-brand">
        <div className="login-brand-content">
          <img className="login-logo" src="/neos-logo.png" alt="NEOS" />
          <span className="login-eyebrow">Life Reinvented</span>
          <h1 className="login-tagline">
            Operations
            <br />
            <span className="login-tagline-accent">Ops Desk</span>
            <br />
            for autopilot
          </h1>
          <p className="login-description">
            Start submission processing, follow its progress and work the service inbox in one
            place.
          </p>
        </div>
      </div>

      <main className="login-panel">
        <div className="login-card">
          <div className="login-card-logo">
            <img className="login-logo login-logo-sm" src="/neos-logo.png" alt="NEOS" />
          </div>
          <h2 className="login-title">Welcome back</h2>
          <p className="login-subtitle">Sign in to continue to Ops Desk.</p>
          {authError ? (
            <Callout.Root color="red" role="alert" mb="3">
              <Callout.Text>
                {authError === 'role'
                  ? 'Your account does not have access to Ops Desk. Ask an administrator for the operations role.'
                  : 'Sign-in did not complete. Please try again.'}
              </Callout.Text>
            </Callout.Root>
          ) : null}
          {/* Arity-0 wrapper: onClick would otherwise pass the MouseEvent as `returnTo`. */}
          <button type="button" className="login-button" onClick={() => login(returnTo)}>
            <LogIn size={18} aria-hidden="true" />
            Sign in with Auth0
          </button>
          <p className="login-footer">Your session is managed securely by the server.</p>
        </div>
      </main>
    </div>
  );
}
